import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-slate-950 text-slate-200 flex flex-col font-sans" data-id="element-83">
      <Header data-id="element-84" />
      <main className="flex-grow pt-16" data-id="element-85">{children}</main>
      <Footer data-id="element-86" />
    </div>;
}